import Vue from 'vue';
import { Decrypt, Encrypt } from "@/util/secret";

Vue.prototype.$Decrypt = Decrypt;    // 解密
Vue.prototype.$Encrypt = Encrypt;    // 加密
